import { Certificate } from '../entities/certificate';
import { http } from '../http';

export async function getSignatureSrokeDownloadUrl(
	certificateSerial: Certificate['certificate_id'],
) {
	try {
		const signatureStrokeDownloadUrlResponse = await http.get<{
			download_url: string | null;
		}>(`certificates/${certificateSerial}/signature`);
		if (signatureStrokeDownloadUrlResponse) {
			return signatureStrokeDownloadUrlResponse.download_url;
		} else {
			throw new TypeError(
				'Response to GET certificate signature was not valid',
			);
		}
	} catch (exception) {
		console.debug('usecase', exception);
		return null
	}
}
